<template functional>
  <div
    class="dataset-cell-tag tag is-capitalized"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class, $options.formatData(props, 'cls')]"
  >
    <template v-if="$options.formatData(props, 'router_params')">
      <a @click="$options.goTo(props, parent)">{{ props.value }}</a>
    </template>
    <template v-else>
      {{ props.value }}
    </template>
  </div>
</template>

<script>
// this cell module take format_data is router
// because this is functional component, it require
// router object from parent component.
// make sure router module assigned to current app
export default {
  name: 'DatasetCellTag',
  props: {
    row: { type: Object, default: () => ({}) },
    column: { type: Object, default: () => ({}) },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: () => null,
    },
  },
  goTo: (props, parent) => {
    const route = props.column.format_data.router_params
    if (typeof route === 'function') return parent.$router.push(route(props))
    else parent.$router.push(route)
  },
  formatData: (props, key) => {
    if (props.column.format_data) return props.column.format_data[key]
    else null
  },
}
</script>

<style lang="scss">
.dataset-cell-tag a {
  color: #666666;
}

.dataset-cell-tag.is-expanded {
  width: 100%;
  a {
    display: block;
    width: 100%;
    text-align: center;
  }
}
</style>
